module.exports = __webpack_public_path__ + "img/18_33.72da6548.png";